// components/FileUploadComponent.tsx
import React, {useState} from 'react';

interface FileUploadProps {
    files: File[];
    onFilesChange: (files: File[]) => void;
    disabled?: boolean;
    maxFiles?: number;
    maxSize?: number; // MB 단위
}

const FileUploadComponent: React.FC<FileUploadProps> = ({
                                                            files,
                                                            onFilesChange,
                                                            disabled = false,
                                                            maxFiles = 3,
                                                            maxSize = 10,
                                                        }) => {
    const [fileInputs, setFileInputs] = useState<number[]>([1]);

    const allowedExtensions = ['doc', 'docx', 'hwp', 'ppt', 'pptx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'pdf'];

    // 파일 추가 버튼
    const handleAddFileInput = () => {
        if (fileInputs.length >= maxFiles) {
            alert(`파일은 최대 ${maxFiles}개까지 첨부 가능합니다.`);
            return;
        }
        setFileInputs([...fileInputs, fileInputs.length + 1]);
    };

    // 파일 입력 필드 삭제
    const handleRemoveFileInput = () => {
        if (fileInputs.length === 1) {
            alert('최소 1개의 파일 입력란은 유지되어야 합니다.');
            return;
        }
        const lastIndex = fileInputs.length - 1;
        const newFileInputs = fileInputs.slice(0, -1);
        const newFiles = files.filter((_, i) => i !== lastIndex);
        setFileInputs(newFileInputs);
        onFilesChange(newFiles);
    };

    // 파일 선택
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;

        // 파일 확장자 검증
        const parts = selectedFile.name.split('.');
        const fileExtension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';

        if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
            alert('지원하지 않는 파일 형식입니다.');
            e.target.value = '';
            return;
        }

        // 파일 크기 검증
        if (selectedFile.size > maxSize * 1024 * 1024) {
            alert(`파일 크기는 ${maxSize}MB 이하만 가능합니다.`);
            e.target.value = '';
            return;
        }

        const newFiles = [...files];
        newFiles[index] = selectedFile;
        onFilesChange(newFiles);
    };

    // 개별 파일 삭제
    const handleDeleteFile = (index: number) => {
        const newFiles = [...files];
        newFiles[index] = null as any;
        onFilesChange(newFiles.filter(f => f));

        // input 초기화
        const fileInput = document.getElementById(`file${index}`) as HTMLInputElement;
        if (fileInput) fileInput.value = '';
    };

    return (
        <div className="form-item">
            <label htmlFor="" className="input-tit">
                파일첨부
                <button type="button" className="delete-btn" onClick={handleRemoveFileInput} disabled={disabled}>
                    <span><i className="fa-solid fa-minus"></i></span>삭제
                </button>
                <button type="button" className="add-btn" onClick={handleAddFileInput} disabled={disabled}>
                    <span><i className="fa-solid fa-plus"></i></span>추가
                </button>
            </label>

            {fileInputs.map((inputId, index) => (
                <div key={inputId} className="input-box">
                    <div className="file-upload">
                        <input
                            type="text"
                            className="upload-name"
                            value={files[index]?.name || ''}
                            placeholder="파일이 없습니다."
                            readOnly
                        />
                        <input
                            type="file"
                            id={`file${index}`}
                            className="upload-hidden"
                            onChange={(e) => handleFileChange(e, index)}
                            disabled={disabled}
                        />
                        <button
                            type="button"
                            className="delete"
                            onClick={() => handleDeleteFile(index)}
                            disabled={!files[index] || disabled}
                        >
                            <span className="blind">삭제</span>
                            <i className="fa-regular fa-trash-can"></i>
                        </button>
                    </div>
                    <label htmlFor={`file${index}`} className="inp-btn">
                        <span>파일찾기</span>
                    </label>
                </div>
            ))}

            <div className="guide-box mt10">
                <ul className="guidF-list">
                    <li>파일은 최대 {maxFiles}개까지 파일 용량은 {maxSize}MB이하만 가능합니다.</li>
                    <li>파일첨부는 DOC,HWP,PPT,EXCEL,JPEG,PNG,PDF만 가능합니다.</li>
                </ul>
            </div>
        </div>
    );
};

export default FileUploadComponent;